import SupervisorService from '@/services/supervisorService';

const setSelectedSupervisorWallboard = (state, wallboard) => {
  state.commit('setSelectedSupervisorWallboard', wallboard || {});
};

const requestSupervisedAgents = ({ commit, rootGetters }) => {
  const loggedInAgent = rootGetters['AGENT/loggedInAgent'];
  const supervisorId = loggedInAgent.isWallboard ? loggedInAgent.userId : loggedInAgent.id;

  return SupervisorService.getSupervisedAgents(supervisorId).then(response => {
    const supervisedAgents = response.data;

    supervisedAgents.map(supervisedAgent => {
      Object.keys(supervisedAgent).forEach(headerKey => {
        if (headerKey === 'assignedBP') {
          supervisedAgent[headerKey] = supervisedAgent[headerKey].join(', ');
        } else if (
          typeof supervisedAgent[headerKey] === 'object' &&
          supervisedAgent[headerKey] &&
          'value' in supervisedAgent[headerKey]
        ) {
          supervisedAgent[headerKey] = supervisedAgent[headerKey].value;
        } else if (supervisedAgent[headerKey] === null) {
          supervisedAgent[headerKey] = '';
        }
      });
      return supervisedAgent;
    });

    if (supervisedAgents) {
      commit('setSupervisedAgents', supervisedAgents);

      return supervisedAgents;
    }
  });
};

const requestSupervisedInteractions = ({ commit, rootGetters }) => {
  const supervisorId = rootGetters['AGENT/loggedInAgent'].id;
  return SupervisorService.getSupervisedInteractions(supervisorId).then(response => {
    const supervisedInteractions = response.data;

    supervisedInteractions.map(supervisedInteraction => {
      Object.keys(supervisedInteraction).forEach(headerKey => {
        if (headerKey === 'demands') {
          supervisedInteraction[headerKey] = supervisedInteraction[headerKey].join(', ');
        } else if (supervisedInteraction[headerKey] === null) {
          supervisedInteraction[headerKey] = '';
        }
      });

      const agent = rootGetters['SUPERVISOR/getSupervisedAgents'].find(
        agent => agent.agentId === supervisedInteraction.agentId
      );

      supervisedInteraction.agentState = agent ? agent.agentState : '';
      supervisedInteraction.agentStateTime = agent ? agent.agentStateTime : '';
      supervisedInteraction.activeBp = agent ? agent.activeBp : '';
      // Should be coming from the interaction, not only from Agent Current Handling Time
      supervisedInteraction.interactionStateTime = agent ? agent.currentInteractionHandlingTime : '';

      return supervisedInteraction;
    });

    if (supervisedInteractions) {
      commit('setSupervisedInteractions', supervisedInteractions);

      return supervisedInteractions;
    }
  });
};

export default {
  setSelectedSupervisorWallboard,
  requestSupervisedAgents,
  requestSupervisedInteractions
};
